import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { AtrtributeTshirtSizeDTO, EventsApiService } from 'features/events';
import { queryClient } from 'providers';

import { eventsQueryKeys } from './query-keys';

const { updateAttributeRacekit } = EventsApiService();

export const useCraeteAttributeRacekit = () => {
    const { message } = App.useApp();

    return useMutation(
        (payload: AtrtributeTshirtSizeDTO) => {
            return updateAttributeRacekit(payload);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                message.success('race-kit updated successfully');
            },
        },
    );
};
